exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dp-zoom{position:fixed;height:28px;bottom:8px;right:8px;text-align:right}.dp-zoom .zoom-btn{cursor:pointer;display:inline-block;width:22px;height:22px;line-height:28px;font-size:24px;color:#666}.dp-zoom .zoom-btn.zoom-minus-disable,.dp-zoom .zoom-btn.zoom-plus-disable{opacity:.5}.dp-zoom .zoom-btn.icon-srt-plus{margin-right:50px}.dp-zoom .zoom-text{font-size:18px;height:22px;line-height:22px;margin:0 5px}.dp-zoom.dp-zoom-iphone .content{border-radius:35px;padding:2px 0;margin-right:5px;width:130px;text-align:right;display:inline-block}.dp-zoom.dp-zoom-iphone .zoom-btn.icon-srt-plus{margin-right:10px}", ""]);

// exports
